<script lang="ts">
	import Spinner from './Spinner.svelte';

	export let spinner = false;
	export let title: string;
	export let visible = true;
	export let absolute = false;
	export let verticalCenter = true;
	let background = true;
</script>

{#if visible}
	<div class="overlay" class:absolute class:background on:click={() => (background = false)}>
		<div class="content" class:verticalCenter>
			{#if spinner}
				<Spinner />
			{/if}
			{#if title}
				<div class="mdc-typography--headline3 loading-title">{title}</div>
			{/if}
			<slot />
		</div>
	</div>
{/if}

<style>
	.overlay {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		z-index: 1;
		pointer-events: none;
	}

	.background {
		background-color: var(--background-color-transparent-3);
		backdrop-filter: blur(2px);
		pointer-events: initial;
	}

	.content {
		position: fixed;

		left: 50%;
		transform: translateX(-50%);
		text-align: center;
	}

	.content.verticalCenter {
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.loading-title {
		margin-top: 2rem;
	}

	.absolute.overlay {
		position: absolute;
	}

	.absolute.overlay .content {
		position: absolute;
	}
</style>
